import {MailerDomain, PaginatedMailerDomain} from '@app/modules/shared/models';

export interface IMailerDomainState {
  mailerDomain: MailerDomain;
  mailerDomains: MailerDomain[];
  paginatedMailerDomains: PaginatedMailerDomain;
  success: string;
  error: string;
}

export const initialMailerDomainState: IMailerDomainState = {
  mailerDomain: null,
  mailerDomains: [],
  paginatedMailerDomains: null,
  success: '',
  error: ''
};
